import { api_get, api_post, stringfy_post } from './../../../utils/http'

const baseUri = '/search/api'

/**
 * 1.查询试卷
 */
function paperList(params: any) {
  return api_post(baseUri + '/paper/list', params)
}
/**
 * 2.查询试卷详情
 */
function paperDetail(params: any) {
  return api_get(baseUri + '/paper/detail', params)
}
/**
 * 3.查询试卷文档
 */
function paperDoc(params: any) {
  return api_get(baseUri + '/paper/doc', params)
}
/**
 * 4.获取基础信息
 */
function getInitInfo(params: any) {
  return api_get(baseUri + '/paper/', params)
}

/**
 * 5.获取基础信息
 */
function otherAccounts(params: any) {
  return api_get(baseUri + '/auth/account/all', params)
}
/**
 * 6.下载接口2
 */
function paperDocS2(params: any) {
  return api_post(baseUri + '/paper/doc-s2', params)
}
/**
 * 7.获得最新的用户信息
 */
function getCurrentUserInfo(params: any) {
  return api_post(baseUri + '/auth/user-info', params)
}
/**
 * 8.获取用户已有的下载券数量
 */
function getCouponCount(params: any) {
  return api_get(baseUri + '/personal/membership/coupon-num', params)
}
/**
 * 9.组卷预览接口
 */
function getPreviewInfo(params: any) {
  return api_get(baseUri + '/question_cart/list_detail', params)
}
/**
 * 10.获取邀请注册链接
 */
function getInventLink(params: any) {
  return api_get(baseUri + '/auth/register-invitation', params)
}
/**
 * 11.获取列表
 */
function getPersonInventList(params: any) {
  return api_get(baseUri + '/personal/invitation/list', params)
}
/**
 * 12.获取个人列表
 */
function getPersonMemeberList(params: any) {
  return api_post(baseUri + '/personal/membership/list', params)
}
/**
 * 13.获取个人
 */
function getPaperListDetail(params: any) {
  return api_get(baseUri + '/paper/list_detail', params)
}
/**
 * 14. 通过 ID 获取一个 CMS 资源
 */
function getSourceInfo(params: any) {
  return api_post(`${baseUri}/cms_resource/id`, params)
}

// 获取资源预览地址
function getCMSResourceById(params: any) {
  return api_post(baseUri + '/cms_resource/preview', params)
}

//
function unZipfile(params: any) {
  return api_post(baseUri + '/cms_resource/zipfile/unzip', params)
}

//
function getDownloadUrl(params: any) {
  return api_post(baseUri + '/cms_resource/download', params)
}

// 获取市区
function getRegions(params: any) {
  return api_get(baseUri + '/common/regions', params)
}
export {
  getCouponCount,
  getCurrentUserInfo,
  paperList,
  paperDetail,
  paperDoc,
  getInitInfo,
  otherAccounts,
  paperDocS2,
  getPreviewInfo,
  getInventLink,
  getPersonInventList,
  getPersonMemeberList,
  getPaperListDetail,
  getCMSResourceById,
  unZipfile,
  getDownloadUrl,
  getSourceInfo,
  getRegions
}
